import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { ComponentDemoComponent } from './component-demo/component-demo.component';
import { SharedModule } from '../shared.module';
import { FormsModule } from "@angular/forms";
import { ButtonDemoComponent } from './button-demo/button-demo.component';
import { CheckboxDemoComponent } from './checkbox-demo/checkbox-demo.component';
import { SelectDemoComponent } from './select-demo/select-demo.component';
import { DatepickerDemoComponent } from './datepicker-demo/datepicker-demo.component';
import { PopupDemoComponent } from './popup-demo/popup-demo.component';
import { ValidationSummaryDemoComponent } from './validation-summary-demo/validation-summary-demo.component';
import { GridDemoComponent } from './grid-demo/grid-demo.component';
import { UIModule } from 'app/shared/UI.module';
import { InfoPopupDemoComponent } from './info-popup-demo/info-popup-demo.component';
import { DFDSUIModule } from '../dfds-ui.module';
import { Popup2DemoComponent } from './popup2-demo/popup2-demo.component';

const appRoutes: Routes = [
    { path: 'componentdemo', component: ComponentDemoComponent }
];

@NgModule({
    imports: [
        CommonModule,
        RouterModule.forRoot(appRoutes, { relativeLinkResolution: 'legacy' }),
        SharedModule,
        UIModule,
        DFDSUIModule,
        FormsModule
    ],
    declarations: [
        ComponentDemoComponent,
        ButtonDemoComponent,
        CheckboxDemoComponent,
        SelectDemoComponent,
        DatepickerDemoComponent,
        PopupDemoComponent,
        Popup2DemoComponent,
        ValidationSummaryDemoComponent,
        GridDemoComponent,
        InfoPopupDemoComponent
    ]
})
export class ComponentDemoModule { }
